import BaseService from './baseService';

class MaksimumSubmissions extends BaseService {
  async getMaksimumSubmissions(opts = {}) {
    this.endPoint = '/maksimum-submissions';
		return this.get(opts);
  }
  async updateMaksimumSubmissionsItems(id,payload,opts={}){
    this.endPoint = '/update-maksimum-submissions';
    return await this.putOne(id,payload,opts);
  }
}

export default new MaksimumSubmissions();